import { useLoggedInMember } from "@/modules/auth/states";
import { getZaniaTeamMemberRoles } from "@/modules/team/states";
import { useMemo } from "react";

export const useIsAdmin = () => {
  const member = useLoggedInMember();

  return useMemo(() => {
    if (!member) return false;
    const { isTeamOrgAdmin, isTeamAdmin } = getZaniaTeamMemberRoles("", member);
    return isTeamOrgAdmin || isTeamAdmin;
  }, [member]);
};
